import { AccountingPlatformSyncStatusResponseData, apiClient } from '@melio/javascript-sdk';

import { useModelApi, UseModelApiProps, UseModelApiResult } from '../../core';

export type AccountingPlatformsSyncStatusProps = UseModelApiProps<AccountingPlatformSyncStatusResponseData>;
export type AccountingPlatformsSyncStatusModel = UseModelApiResult<AccountingPlatformSyncStatusResponseData>;

export const useAccountingPlatformSyncStatus = (
  props: AccountingPlatformsSyncStatusProps
): AccountingPlatformsSyncStatusModel => {
  const client = apiClient.accountingPlatformSyncStatus();

  return useModelApi<AccountingPlatformSyncStatusResponseData>({
    ...props,
    queryKey: 'accounting-platform-sync-status',
    queryFn: () => client.get(props.id as string),
  });
};
